


export const formatDate = (date:any) => {
    if (!date) return 'N/A';


    const dateObj = typeof date === 'string' ? new Date(date) : date;


    if (isNaN(dateObj.getTime())) return 'Invalid Date';


    const options: any = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        // weekday: 'short',
    };


    return new Intl.DateTimeFormat('en-US', options).format(dateObj);
};
